import { jsx as _jsx } from "nativewind/jsx-runtime";
import React from 'react';
import { FlatList } from 'react-native';
import styled from 'styled-components/native';
import { color } from '@/constant/color';
import { LogParamsProvider } from '@/logging/LogParamsProvider';
import SearchLoading from '@/screens/SearchScreen/components/SearchLoading';
import SearchNoResult from '@/screens/SearchScreen/components/SearchNoResult';
import ToiletCard from '@/components/toilet/ToiletCard';
export default function ToiletListView({ searchResults, isLoading, isVisible, }) {
    return (_jsx(LogParamsProvider, { params: { search_view_mode: 'list' }, children: _jsx(Container, { isVisible: isVisible, children: isLoading ? (_jsx(SearchLoading, {})) : searchResults.length === 0 ? (_jsx(SearchNoResult, {})) : (_jsx(FlatList, { contentContainerStyle: { paddingBottom: 100 }, keyboardDismissMode: "on-drag", renderItem: ({ item }) => (_jsx(ItemWrapper, { children: _jsx(ToiletCard, { item: item }) }, item.id)), data: searchResults })) }) }));
}
const Container = styled.View `
  display: ${props => (props.isVisible ? 'flex' : 'none')};
  flex-direction: column;
  flex: 1;
  background-color: ${color.white};
`;
const ItemWrapper = styled.View `
  padding: 20px;
  border-top-width: 1px;
  border-top-color: ${() => color.gray20};
`;
